import React from 'react';
import { TabType } from '../types/booking.types';

interface TabItem {
  id: TabType;
  label: string;
  icon: string;
  count: number;
}

interface TabNavigationProps {
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
  servicesCount: number;
  paymentsCount: number;
  paymentRequestsCount: number;
  expensesCount: number;
  refundsCount?: number;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  setActiveTab,
  servicesCount,
  paymentsCount,
  paymentRequestsCount,
  expensesCount,
  refundsCount = 0,
}) => {
  const tabs: TabItem[] = [
    { id: 'summary', label: 'Summary', icon: '📊', count: 0 },
    { id: 'services', label: 'Services', icon: '📋', count: servicesCount },
    { id: 'payments', label: 'Payments', icon: '💰', count: paymentsCount },
    { id: 'payment_requests', label: 'Payment Requests', icon: '📩', count: paymentRequestsCount },
    { id: 'expenses', label: 'Expenses', icon: '💸', count: expensesCount },
    { id: 'job', label: 'Job Management', icon: '👷', count: 0 },
    { id: 'adjustments', label: 'Adjustments', icon: '⚙️', count: 0 },
    { id: 'refunds', label: 'Refunds', icon: '💳', count: refundsCount },
  ];

  return (
    <div className="mb-6 border-b border-gray-200">
      <nav className="flex space-x-1 overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center space-x-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
              activeTab === tab.id
                ? 'border-blue-500 text-blue-600 bg-blue-50'
                : 'border-transparent text-gray-600 hover:text-gray-800 hover:border-gray-300'
            }`}
          >
            <span>{tab.icon}</span>
            <span>{tab.label}</span>
            {tab.count > 0 && (
              <span
                className={`px-2 py-0.5 text-xs rounded-full ${
                  activeTab === tab.id ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'
                }`}
              >
                {tab.count}
              </span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default TabNavigation;
